import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from "react-i18next";

import './styles.css';

/* Bandeau cookies discret (bas-gauche, non bloquant) — design "Signal".
   Apparaît après un court délai, seulement si aucun consentement enregistré. */
const CookiesModal = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [manageCookies, setManageCookies] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(true);
  const [analyticsChecked, setAnalyticsChecked] = useState(true);
  const [targetChecked, setTargetChecked] = useState(true);

  const handleClose = () => setIsOpen(false);

  const handleAcceptClicked = () => {
    sessionChecked && Cookies.set('session_id', 'XXXXX');
    analyticsChecked && Cookies.set('analytics_id', 'XXXXX', { expires: 365 });
    targetChecked && Cookies.set('targeting_id', 'XXXXXX', { expires: 365 });
    handleClose();
  };

  const handleAcceptAll = () => {
    Cookies.set('session_id', 'XXXXX');
    Cookies.set('analytics_id', 'XXXXX', { expires: 365 });
    Cookies.set('targeting_id', 'XXXXXX', { expires: 365 });
    handleClose();
  };

  useEffect(() => {
    const anyCookies =
      Cookies.get('session_id') || Cookies.get('analytics_id') || Cookies.get('targeting_id');
    if (anyCookies) return;
    // léger délai : on laisse l'utilisateur découvrir la page d'abord
    const id = setTimeout(() => setIsOpen(true), 1200);
    return () => clearTimeout(id);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="ck-banner" role="dialog" aria-label={t('signal.cookies')}>
      <div className="ck-banner__head">
        <span className="ck-banner__title">{t('overview.cookies-title')} 🍪</span>
        <button type="button" className="ck-banner__close" onClick={handleClose} aria-label={t('signal.close')}>
          ✕
        </button>
      </div>

      {!manageCookies ? (
        <p className="ck-banner__text">{t('overview.cookies-des')}</p>
      ) : (
        <div className="ck-banner__checks">
          <label className="ck-check">
            <input type="checkbox" checked={sessionChecked} onChange={() => setSessionChecked(!sessionChecked)} />
            {t('overview.sess-tracking')}
          </label>
          <label className="ck-check">
            <input type="checkbox" checked={analyticsChecked} onChange={() => setAnalyticsChecked(!analyticsChecked)} />
            {t('overview.analtics-tracking')}
          </label>
          <label className="ck-check">
            <input type="checkbox" checked={targetChecked} onChange={() => setTargetChecked(!targetChecked)} />
            {t('overview.targeting')}
          </label>
        </div>
      )}

      <div className="ck-banner__actions">
        {!manageCookies ? (
          <>
            <button className="ck-btn ck-btn--ghost" onClick={() => setManageCookies(true)}>
              {t('overview.manage-cookies')}
            </button>
            <button className="ck-btn ck-btn--primary" onClick={handleAcceptAll}>
              {t('overview.accept-all')}
            </button>
          </>
        ) : (
          <button className="ck-btn ck-btn--primary" onClick={handleAcceptClicked}>
            {t('overview.confirm-selection')}
          </button>
        )}
      </div>
    </div>
  );
};

export default CookiesModal;
